export default __webpack_public_path__ + "static/media/slide1.7b84503e.jpg";